export default "https://fenwan.cdn.bcebos.com/gamecenter/static/game/assets/imgs/rec-download-drawer-title.72a11a81.png";